import React from 'react';
import classNames from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ParagraphsRenderer } from '../../../components';

import './style.scss';

const NodeOverviewPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeOverviewPage');
  const node = entity.toJS();
  const heroTitle = node.title[0].value;
  const heroBody = node.body[0]?.processed;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="NodeOverviewPage__hero__wrapper">
              <div className="NodeOverviewPage__hero__wrapper__text">
                <h1 className="NodeOverviewPage__hero__wrapper__title">{heroTitle}</h1>
                {heroBody && (
                  <div className="NodeOverviewPage__hero__wrapper__body">
                    <WysiwygField
                      property="schema:text"
                      className="text--large"
                      html={heroBody}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>

      <ParagraphsRenderer paragraphs={entity.get('field_paragraphs')} />
    </article>
  );
};

export default NodeOverviewPage;
